<template>
  <div class="operations">
    <div class="container">
      <h1>
        <font-awesome-icon icon="car-crash" />
        Feuerwehr Pfaffenhofen im Einsatz</h1>
      <p class="text">
          Das Einsatzspektrum erstreckt sich von Bränden über Verkehrsunfällen bis hin zu 
          Hochwassereinsätzen. <br>
          Bis zu 100 Einsätze fährt die Feuerwehr Pfaffenhofen im Jahr,
          ein Großteil davon sind technische Hilfeleistungen. <br><br>
          <b>Zuletzt war die Feuerwehr hier im Einsatz:</b> 
      </p>
      <div class="dots">
        <font-awesome-icon icon="circle" :class="{'circle-active': active[3]}" />
        <font-awesome-icon icon="circle" :class="{'circle-active': active[2]}" />
        <font-awesome-icon icon="circle" :class="{'circle-active': active[1]}" />
        <font-awesome-icon icon="circle" :class="{'circle-active': active[0]}" />
      </div>
      <div class="flex-menu">
        <div class="nav nav-left" @click="moveBackward()">
          <font-awesome-icon icon="chevron-left"/>
        </div>
        
        <div class="flex-row">
          <div class="card" v-for="item in operations.slice(0,2)" :key="item.id" >
            <div class="image-container" v-if="item.image_files && item.image_files.length > 0">
              <router-link to="einsatz">
                <img :src="item.image_files[0].thumb_url">
              </router-link>
            </div>
          <div class="content">
            <div class="time">
              <font-awesome-icon icon="clock" /> {{item.start}}
            </div>
            <div class="title">{{item.title}}</div>
            <div class="seperator">
              <div class="block"></div>
            </div>
            <router-link to="einsatz">
              <div class="body" v-html="item.description"></div>
            </router-link>
          </div>
          </div>
        </div>

        <div class="nav nav-right" @click="moveForward()">
          <font-awesome-icon icon="chevron-right"/>
        </div>
      </div>

      <div class="btn-bar">
        <div class="btn-line"></div>
        <div class="btn">
          <div class="btn-inner">
            <router-link to="einsatz">
              Mehr Anzeigen <br>
              <font-awesome-icon icon="chevron-down"/>
            </router-link>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { EventBus } from '../event-bus.js'

export default {
  name: 'HomeOperations',
  data () {
    return {
      operations: "12",
      active: [true, true, false, false]
    }
  },
  mounted () {
    this.userID = this.$session.get("userID")
    this.axios.get('https://ff-pfaffenhofen.de/api/v1/operations')
      .then( (res) => {
        this.operations = res["data"]["operations"]

        this.operations.forEach(item => {
          let length = Math.min(180, item.description.length)
          item.description = item.description.substring(0, length)

          if(item.description.length == 180) {
            item.description += "..."
          }

        });
      })

    EventBus.$on('logout', () => {
      this.userID = ""
    })
    EventBus.$on('login', (userID) => {
      this.userID = userID
    })
  },
  methods: {
    moveForward() {
      let op = this.operations.shift()
      this.operations.push(op)

      let act = this.active.pop()
      this.active.unshift(act)
      
    },
    moveBackward() {
      let op = this.operations.pop()
      this.operations.unshift(op)

      let act = this.active.shift()
      this.active.push(act)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/theme.scss";

a {
  text-decoration: none;
}

.operations {
  background: $light-1;
  padding: 50px 0px;
  position: relative;
}

h1 {
  color: $dark;
  font-size: 20px;
  text-align: center;

  svg {
    color: $primary-0;
    font-size: 38px;
    margin-right: 15px;
  }

  @include mini {
    font-size: 30px;
  }
}

.text {
  text-align: center;
  color: $dark;
  opacity: 0.8;
}

.dots {

  display: none;
  
  @include max {
    flex-direction: row-reverse;
    margin-bottom: 10px;
    margin-right: 65px;
    margin-top: -25px;
    display: flex;
  }

  svg {
    opacity: 0.2;
    font-size: 8px;
    margin: 0px 2px;
  }

  .circle-active {
    opacity: 1;
    color: $primary-0 !important;
  }
}

.flex-menu {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.flex-row {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  flex-grow: 1;
  flex-shrink: 1;
  width: 100%;

  @include mini {
    width: 470px;
  }
}

.card {
  width: 100%;
  height: 150px;
  box-shadow: $shadow-light;
  background: $light-0;
  border-radius: 4px;
  border: 1px solid lighten($gray-0, 15%);
  display: flex;
  margin: 0 10px 20px 10px;

  @include mini {
    height: 180px;
  }

  @include desktop {
    width: 470px;
  }

  img {
    width: 150px;
    height: 150px;
    object-fit: cover;
    border: 1px solid lighten($gray-0, 15%);
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;

    @include mini {
      width: 180px;
      height: 180px;
    }

    &:hover {
      filter: brightness(80%);
    }
  }

  .content {
    padding: 10px 20px;
    overflow: hidden;
    flex-basis: 100%;
  }

  .title {
    font-weight: 600;
    color: $dark;
    font-size: 16px;
    color: $primary-0;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 80%;

    @include mini {
      font-size: 20px;
    }
  }

  .body {
    color: $dark;
    opacity: 0.8;
    margin-top: 10px;
    height: 56px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px;

    @include mini {
      font-size: 16px;
      height: 72px;
    }
  }

  .time {
    font-weight: 600;
    color: $dark;
    opacity: 0.7;
    font-size: 14px;
    margin-bottom: 5px;
  }

  .block {
    border-top: 1px solid lighten($gray-0, 15%);
    width: 100%;
    margin: 12px auto;
  }

  .seperator {
    display: none;
    @include mini {
      display: block;
    }
  }

  &:nth-child(2) {
    flex-direction: row-reverse;

    img {
      border-left: 1px solid lighten($gray-0, 15%);

      @include desktop {
        border-left: 0px;
        border-right: 1px solid lighten($gray-0, 15%);
      }

    }

    @include desktop {
      flex-direction: row;
    }
  }
}

.btn-bar {
  margin: 0px 0 60px 0;
  position: relative;

  .btn-line {
    position: absolute;
    height: 2px;
    background: darken($light-0, 10%);
    width: 100%;
    top: 15px;
    z-index: 0;
  }

  .btn {
    position: absolute;
    top: 0;
    text-align: center;
    width: 100%;
  }

  .btn-inner {
    width: 270px;
    background: $light-1;
    z-index: 1;
    margin: 0 auto;
  }

  a {
    border: none;
    opacity: 0.6;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 15px;
    cursor: pointer;
    color: $dark;
    text-decoration: none;

    &:hover {
      opacity: 0.8;
    }
  }
}

.nav {
  font-size: 50px;
  opacity: 0.2;
  color: $dark-0;
  cursor: pointer;
  margin: 51px 0 49px 0;
  display: none;

  &:hover {
    opacity: 1;
    color: $primary-0;
  }

  @include max {
    display: block;
  }
}

.nav-left {
  margin-right: 20px;
}

.nav-right {
  margin-left: 20px;
}

</style>
